{
  "barcloudUrl": "http://localhost",
  "url": "https://localhost:44325",
  "enterpriseApi": "https://localhost:44325",
  "barcloudUrlLocal": "https://localhost:44325",
  "urlLocal": "https://localhost:44325",
  "enterpriseApiLocal": "https://localhost:44325",
  "shoppingCartUrl": "http://localhost:4300",
  "releaseNoteUrl": "https://asapsystems.com/inventory-asset-tracking-release-notes/",
  "contactUsUrl": "https://barcloud.com/company/contact-us/",
  "companyUrl": "https://asapsystems.com/company/barcloud-about-us/",
  "returnPolicyUrl": "https://barcloud.com/return-policy/",
  "privacyPolicyUrl": "https://barcloud.com/privacy-policy/",
  "termsOfServiceUrl": "https://barcloud.com/terms-of-service/",
  "termsAndConditionsUrl": "https://barcloud.com/terms-of-service/",
  "wikiUrl": "https://barcloudwiki.asapsystems.com/BarcloudNG/",
  "videoUrl": "https://www.youtube.com/@ASAPSystems",
  "contactSupportUrl": "https://barcloud.com/company/contact-us/",
  "scheduleTrainingUrl": "https://outlook.office365.com/owa/calendar/ASAPSystemsTrainingandSupport@asapsystems.com/bookings/"
}
